<template>
  <div>
    <div class="ml-l pl-l mb-l pb-l">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <div class="container">
      <h3>优惠券详情</h3>
      <el-form label-position="left" label-width="120px">
        <el-form-item label="券名称">
          <div>{{ coupon.name }}</div>
        </el-form-item>
        <el-form-item label="面值">
          <div>{{ $amount1(coupon.amount) }}元</div>
        </el-form-item>
        <el-form-item label="使用规则">
          <div>满{{ $amount1(coupon.reach) }}可用</div>
        </el-form-item>
        <el-form-item label="有效时间">
          <div v-if="coupon.timebegin == 0 && coupon.timeend == 0">不限制</div>
          <div v-if="coupon.timebegin > 0 || coupon.timeend > 0">{{ new Date(coupon.timebegin * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }} - {{ new Date(coupon.timeend * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>
        <el-form-item label="适用商品">
          <div>
            <div v-if="coupon.producttype === 0">可用于全部商品</div>
            <div v-if="coupon.producttype === 1">可用于部分商品</div>
            <div v-if="coupon.producttype === 2">不可用于部分商品</div>
            <div v-if="coupon.producttype !== 0">
              <span :key="product.id" class="coupon-category" v-for="product in coupon.productlist">{{ product.name }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="来源优惠券模版">
          <div @click="$router.push({ name: 'marketing-coupon-template-detail', query: { id: coupon.coupontemplateid } })" class="marketing-link">{{ coupon.coupontemplate.name }}</div>
        </el-form-item>
        <el-form-item label="来源营销规则">
          <div v-if="coupon.frommarketingid" @click="$router.push({ name: 'marketing-detail', query: { id: coupon.frommarketingid } })" class="marketing-link">{{ coupon.frommarketing.name }}</div>
          <div v-if="!coupon.frommarketingid">手动发放</div>
        </el-form-item>
        <el-form-item label="来源订单">
          <div v-if="coupon.fromorderid" @click="$router.push({ name: 'order-detail', query: { id: coupon.fromorderid } })" class="marketing-link">ID: {{ coupon.fromorderid }}</div>
          <div v-if="!coupon.fromorderid">无</div>
        </el-form-item>
        <el-form-item label="用于订单">
          <div v-if="coupon.toorderid" @click="$router.push({ name: 'order-detail', query: { id: coupon.toorderid } })" class="marketing-link">ID: {{ coupon.toorderid }}</div>
          <div v-if="!coupon.toorderid">暂未使用</div>
        </el-form-item>
        <el-form-item label="持有用户">
          <div>{{ coupon.user.nickname }}({{ coupon.user.mobile }})</div>
        </el-form-item>

        <el-form-item label="使用时间" v-if="coupon.toorderid > 0">
          <div>{{ new Date(coupon.updatedat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>

        <el-form-item label="创建时间">
          <div>{{ new Date(coupon.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
export default {
  data() {
    return {
      coupon: {
        user: {},
        coupontemplate: {}
      },
      token: ''
    };
  },
  async created() {
    this.token = getToken();
    const res = await rpc(
      'StoreCouponService.GetCoupon',
      M('IDWithTokenRequest', {
        token: M('Token', { token: this.token }),
        id: this.$route.query.id
      })
    );
    const reslist = await Promise.all([
      rpc(
        'StoreUserService.GetUser',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: res.userid
        })
      ),
      rpc(
        'StoreCouponTemplateService.GetCouponTemplate',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: res.coupontemplateid
        })
      ),
      res.frommarketingid
        ? rpc(
            'StoreMarketingService.GetMarketing',
            M('IDWithTokenRequest', {
              token: M('Token', { token: this.token }),
              id: res.frommarketingid
            })
          )
        : null,
      res.categoryidsList.length
        ? rpc(
            'StoreCategoryService.GetCategoryList',
            M('CategoryListQueryRequest', {
              token: M('Token', { token: this.token }),
              idlistList: res.categoryidsList,
              level: 2,
              count: res.categoryidsList.length,
              sortby: 1
            })
          )
        : null,
      res.productidsList.length
        ? rpc(
            'StoreProductService.GetProductList',
            M('ProductListQueryRequest', {
              token: M('Token', { token: this.token }),
              idlistList: res.productidsList,
              sortby: 1,
              sort: 1,
              count: res.productidsList.length
            })
          )
        : null
    ]);
    res.user = reslist[0];
    res.coupontemplate = reslist[1];
    res.frommarketing = reslist[2];
    res.categorylist = res.categoryidsList.map(item => reslist[3].categorylistList.find(v => v.id === item));
    res.productlist = res.productidsList.map(item => reslist[4].productlistList.find(v => v.id === item));
    this.coupon = res;
  }
};
</script>

<style>
.coupon-category {
  padding: 4px 8px;
  font-size: 12px;
  background-color: #e9e9e9;
  margin-right: 5px;
}
.marketing-link {
  color: rgb(97, 179, 211);
  cursor: pointer;
}
</style>
